/**
 *
 * @param $ - jquery object for making $.ajax call
 * @param profileId - profileId for user to pull vehicles for
 * @param callback - method is called with an array of the saved vehicles for the given user as it's only param
 */
export const getVehiclesForProfile = ($, profileId, callback) => {
	$.ajax({
		type: 'GET',
		url: `/apis/mycars/v1/profiles/${profileId}/vehicles`,
		cache: false,
		data: {
			// fromMedia: hack use this param to signal that we don't need to monitor this ajax request
			// otherwise gets stuck in infinite loop listening to it's own calls
			fromMedia: true,
			statusType: 'SAVED'
		},
		contentType: 'application/json',
		success: data => {
			callback(data.results);
		},
		error: () => {
			callback([]);
		}
	});
};



// WEBPACK FOOTER //
// ./src/helpers/mycars.js